(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ecommerce-header"] && !Shopify.designMode) return;
  try {
    
    (() => {
      const MIN_QUERY_LENGTH = 2;
      const MODEL_FILTER_PARAM = 'filter.p.m.custom.modelli_camera_compatibili';

      const normalize = (value) =>
        String(value || '')
          .toLowerCase()
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          .replace(/[^a-z0-9]+/g, ' ')
          .trim();

      const getSectionId = (form) => {
        const wrapper = form.closest('.shopify-section');
        if (!wrapper) return null;
        return wrapper.id.replace('shopify-section-', '');
      };

      const getCameraModelDataElement = (form) => {
        const sectionId = getSectionId(form);

        if (!sectionId) return null;

        return document.getElementById(`CameraModelData-${sectionId}`);
      };

      const readJsonData = (id, fallbackMessage) => {
        const dataEl = document.getElementById(id);

        if (!dataEl) return [];

        try {
          const parsed = JSON.parse(dataEl.textContent || '[]');
          return Array.isArray(parsed) ? parsed : [];
        } catch (error) {
          console.warn(fallbackMessage, error);
          return [];
        }
      };

      const getModels = (form) => {
        const dataEl = getCameraModelDataElement(form);
        const sectionId = getSectionId(form);
        if (!sectionId || !dataEl) return [];

        return readJsonData(
          `CameraModelData-${sectionId}`,
          'Impossibile leggere i modelli camera:'
        );
      };

      const getUniversalCameraGid = (form) =>
        getCameraModelDataElement(form)?.dataset.universalCameraGid || '';

      const getModelPagination = (form) => {
        const dataEl = getCameraModelDataElement(form);

        return {
          currentPage: Number(dataEl?.dataset.cameraModelCurrentPage || '1'),
          totalPages: Number(dataEl?.dataset.cameraModelTotalPages || '1'),
          pageParam: dataEl?.dataset.cameraModelPageParam || 'page',
        };
      };

      const buildCameraModelPageUrl = (sectionId, pageParam, pageNumber) => {
        const url = new URL(window.location.href);

        url.searchParams.set('section_id', sectionId);
        url.searchParams.set(pageParam, String(pageNumber));

        return url.toString();
      };

      const loadCameraModelPage = async (sectionId, pageParam, pageNumber) => {
        const response = await fetch(buildCameraModelPageUrl(sectionId, pageParam, pageNumber), {
          credentials: 'same-origin',
        });

        if (!response.ok) {
          throw new Error(`HTTP ${response.status}`);
        }

        const html = await response.text();
        const parsedDocument = new DOMParser().parseFromString(html, 'text/html');
        const dataEl = parsedDocument.getElementById(`CameraModelData-${sectionId}`);

        if (!dataEl) {
          throw new Error(`CameraModelData-${sectionId} missing`);
        }

        try {
          const parsed = JSON.parse(dataEl.textContent || '[]');
          if (!Array.isArray(parsed)) {
            throw new Error('CameraModelData JSON is not an array');
          }

          return parsed;
        } catch (error) {
          throw error;
        }
      };

      const mergeCameraModels = (models) => {
        const merged = new Map();

        models.forEach((model) => {
          const key = model.gid || model.url || model.label;

          if (!merged.has(key)) {
            merged.set(key, model);
          }
        });

        return Array.from(merged.values());
      };

      const buildTitleAndQuery = (query) => {
        const terms = query.trim().split(/\s+/).filter(Boolean);

        return terms
          .map((term) => {
            const escapedTerm = term
              .replace(/\\/g, '\\\\')
              .replace(/"/g, '\\"')
              .replace(/:/g, '\\:')
              .replace(/\(/g, '\\(')
              .replace(/\)/g, '\\)');

            return `title:"${escapedTerm}"`;
          })
          .join(' AND ');
      };

      const findMatches = (models, query) => {
        const normalizedQuery = normalize(query);

        if (normalizedQuery.length < MIN_QUERY_LENGTH) return [];

        return models
          .map((model) => {
            const label = normalize(model.label);

            if (label === 'universale') return null;

            const brand = normalize(model.brand);
            const terms = normalize(model.terms);
            const haystack = `${label} ${brand} ${terms}`;

            let score = 0;

            if (label === normalizedQuery) score += 100;
            if (label.startsWith(normalizedQuery)) score += 60;
            if (haystack.includes(normalizedQuery)) score += 30;

            return {
              ...model,
              score,
            };
          })
          .filter((model) => model && model.score > 0)
          .sort((a, b) => b.score - a.score || a.label.localeCompare(b.label));
      };

      const hideSuggestions = (form) => {
        const input = form.querySelector('[data-camera-model-input]');
        const suggestions = form.querySelector('[data-camera-model-suggestions]');
        const header = form.closest('[data-site-header]');

        if (suggestions) {
          suggestions.hidden = true;
          suggestions.innerHTML = '';
        }

        if (input) {
          input.setAttribute('aria-expanded', 'false');
        }

        if (header) {
          header.classList.remove('is-model-search-open');
        }
      };

      const goToModel = (model, universalGid = '') => {
        if (!model || !model.url) return;

        const url = new URL(model.url, window.location.origin);

        if (universalGid && universalGid !== model.gid) {
          url.searchParams.append(MODEL_FILTER_PARAM, universalGid);
        }

        window.location.href = url.toString();
      };

      const renderSuggestions = (form, items, emptyMessage = 'Nessun risultato trovato') => {
        const input = form.querySelector('[data-camera-model-input]');
        const suggestions = form.querySelector('[data-camera-model-suggestions]');
        const header = form.closest('[data-site-header]');

        if (!input || !suggestions) return;

        const matches = findMatches(items, input.value);

        suggestions.innerHTML = '';

        if (matches.length === 0) {
          if (input.value.trim().length >= MIN_QUERY_LENGTH) {
            const empty = document.createElement('div');
            empty.className = 'site-header__model-empty';
            empty.textContent = emptyMessage;
            suggestions.appendChild(empty);
            suggestions.hidden = false;
            input.setAttribute('aria-expanded', 'true');

            if (header) {
              header.classList.add('is-model-search-open');
            }
          } else {
            hideSuggestions(form);
          }

          return;
        }

        for (const model of matches) {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'site-header__model-suggestion';
          button.setAttribute('role', 'option');

          const name = document.createElement('span');
          name.className = 'site-header__model-suggestion-name';
          name.textContent = model.label;

          const brand = document.createElement('span');
          brand.className = 'site-header__model-suggestion-brand';
          brand.textContent = model.brand ? `Marca: ${model.brand}` : model.typeLabel || 'Risultato';

          button.append(name, brand);

          button.addEventListener('click', () => {
            input.value = model.label;
            goToModel(model, getUniversalCameraGid(form));
          });

          suggestions.appendChild(button);
        }

        suggestions.hidden = false;
        input.setAttribute('aria-expanded', 'true');

        if (header) {
          header.classList.add('is-model-search-open');
        }
      };

      const setMode = (form, mode) => {
        const input = form.querySelector('[data-camera-model-input]');
        const modeSelect = form.querySelector('[data-search-mode-select]');

        form.dataset.searchMode = mode;

        if (modeSelect) {
          modeSelect.value = mode;
        }

        if (input) {
          const genericPlaceholder = input.dataset.genericPlaceholder || 'Scrivi qui dentro il prodotto che cerchi!';
          const modelPlaceholder = input.dataset.modelPlaceholder || 'Inserisci il tuo modello di fotocamera e trova tutti i prodotti compatibili!';

          if (mode === 'model') {
            input.placeholder = modelPlaceholder;
          } else {
            input.placeholder = genericPlaceholder;
          }
          input.value = '';
          input.focus();
        }

        hideSuggestions(form);

        const header = form.closest('[data-site-header]');
        if (header) {
          header.classList.remove('is-model-search-open');
        }
      };

      const setupForm = (form) => {
        if (form.dataset.cameraModelSearchReady === 'true') return;

        form.dataset.cameraModelSearchReady = 'true';

        const pagination = getModelPagination(form);
        const sectionId = getSectionId(form);
        let models = getModels(form).map((item) => ({
          ...item,
          typeLabel: 'Modello camera',
        }));
        let modelsFullyLoaded = pagination.totalPages <= 1;
        let modelsLoadPromise = null;
        const input = form.querySelector('[data-camera-model-input]');
        const displayQueryInput = form.querySelector('[data-display-query]');
        const technicalQueryInput = form.querySelector('[data-technical-search-query]');
        const modeSelect = form.querySelector('[data-search-mode-select]');

        const ensureAllModelsLoaded = () => {
          if (modelsFullyLoaded) {
            return Promise.resolve(models);
          }

          if (modelsLoadPromise) return modelsLoadPromise;

          if (!sectionId || pagination.totalPages <= 1) {
            modelsFullyLoaded = true;
            modelsLoadPromise = Promise.resolve(models);
            return modelsLoadPromise;
          }

          const pagesToLoad = [];

          for (let page = 1; page <= pagination.totalPages; page += 1) {
            if (page !== pagination.currentPage) {
              pagesToLoad.push(page);
            }
          }

          modelsLoadPromise = (async () => {
            let loadFailed = false;

            for (const pageNumber of pagesToLoad) {
              try {
                const nextPageModels = await loadCameraModelPage(sectionId, pagination.pageParam, pageNumber);
                models = mergeCameraModels([
                  ...models,
                  ...nextPageModels.map((item) => ({
                    ...item,
                    typeLabel: 'Modello camera',
                  })),
                ]);
              } catch (error) {
                loadFailed = true;
                console.warn('Impossibile caricare tutte le pagine dei modelli camera:', error);
              }
            }

            modelsFullyLoaded = !loadFailed;

            if (loadFailed) {
              throw new Error('Impossibile caricare tutte le pagine dei modelli camera');
            }

            return models;
          })();

          return modelsLoadPromise.finally(() => {
            if (!modelsFullyLoaded) {
              modelsLoadPromise = null;
            }
          });
        };

        if (input) {
          const params = new URLSearchParams(window.location.search);
          const displayQuery = params.get('display_q');

          if (displayQuery) {
            input.value = displayQuery;
          }
        }

        if (modeSelect) {
          modeSelect.addEventListener('change', () => {
            setMode(form, modeSelect.value || 'generic');

            if (modeSelect.value === 'model') {
              void ensureAllModelsLoaded().then(() => {
                if (form.dataset.searchMode === 'model' && input && input.value.trim().length >= MIN_QUERY_LENGTH && modelsFullyLoaded) {
                  renderSuggestions(form, models, 'Nessun modello trovato');
                }
              }).catch(() => {
                hideSuggestions(form);
              });
            }
          });
        }

        if (input) {
          input.addEventListener('input', async () => {
            if (form.dataset.searchMode === 'model') {
              try {
                await ensureAllModelsLoaded();
              } catch (error) {
                hideSuggestions(form);
                return;
              }

              if (form.dataset.searchMode === 'model' && modelsFullyLoaded) {
                renderSuggestions(form, models, 'Nessun modello trovato');
              }

              return;
            }
          });

          input.addEventListener('keydown', (event) => {
            if (form.dataset.searchMode !== 'model') return;

            const suggestions = form.querySelector('[data-camera-model-suggestions]');
            const options = suggestions ? Array.from(suggestions.querySelectorAll('.site-header__model-suggestion')) : [];
            const activeIndex = options.findIndex((option) => option.classList.contains('is-active'));

            if (event.key === 'Escape') {
              hideSuggestions(form);
              return;
            }

            if (!options.length) return;

            if (event.key === 'ArrowDown') {
              event.preventDefault();
              const nextIndex = activeIndex >= options.length - 1 ? 0 : activeIndex + 1;
              options.forEach((option) => option.classList.remove('is-active'));
              options[nextIndex].classList.add('is-active');
              options[nextIndex].scrollIntoView({ block: 'nearest' });
            }

            if (event.key === 'ArrowUp') {
              event.preventDefault();
              const nextIndex = activeIndex <= 0 ? options.length - 1 : activeIndex - 1;
              options.forEach((option) => option.classList.remove('is-active'));
              options[nextIndex].classList.add('is-active');
              options[nextIndex].scrollIntoView({ block: 'nearest' });
            }

            if (event.key === 'Enter' && activeIndex >= 0) {
              event.preventDefault();
              options[activeIndex].click();
            }
          });
        }

        form.addEventListener('submit', (event) => {
          const query = input ? input.value.trim() : '';

          if (form.dataset.searchMode === 'model') {
            event.preventDefault();

            ensureAllModelsLoaded().then(() => {
              const matches = findMatches(models, query);

              if (matches.length > 0) {
                goToModel(matches[0], getUniversalCameraGid(form));
                return;
              }

              if (modelsFullyLoaded) {
                renderSuggestions(form, models, 'Nessun modello trovato');
              }
            }).catch(() => {
              hideSuggestions(form);
            });

            return;
          }

          if (form.dataset.searchMode === 'generic' && input && query) {
            if (displayQueryInput) {
              displayQueryInput.value = query;
            }

            if (technicalQueryInput) {
              technicalQueryInput.value = buildTitleAndQuery(query);
            }
          }
        });

        document.addEventListener('click', (event) => {
          if (!form.contains(event.target)) {
            hideSuggestions(form);
          }
        });
      };

      const init = () => {
        document.querySelectorAll('[data-camera-model-search]').forEach(setupForm);
      };

      init();

      document.addEventListener('shopify:section:load', init);
    })();
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
